import { createFileRoute } from '@tanstack/react-router'
import { ValueStories } from 'pages/valueStories/ValueStories'
import { valueStoriesSearchParams } from 'routes/value-stories/-searchParams'

const RouteComponent = () => {
  const { orgId, siteId } = Route.useSearch()

  return <ValueStories orgId={orgId} siteId={siteId} />
}

export const Route = createFileRoute('/value-stories/')({
  component: RouteComponent,
  staticData: {
    title: 'Value Stories',
    layout: {
      enableScrolling: true,
    },
  },
  validateSearch: valueStoriesSearchParams,
})
